import React from 'react';

class Draggable extends React.PureComponent {
  constructor(props){
    super(props);

    this.startDrag = this.startDrag.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
    this.reset = this.reset.bind(this);
    // this.drag = throttle(this.drag, 50);
    this.drag = this.drag.bind(this);
    this.state = {
      positionX: 0,
      positionY: 0,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
    };
  }

  reset(){
    this.setState({
      positionX: 0,
      positionY: 0,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
    });
  }

  stopDrag(){
    this.setState({
      startX: 0,
      startY: 0,
      offsetX: this.state.positionX,
      offsetY: this.state.positionY,
    })
  }

  startDrag(event){
    this.setState({
      startX: event.clientX,
      startY: event.clientY,
    });
  }

  drag(event){
    if(event.clientX && event.clientY){
      this.setState({
        positionX: (this.state.startX - event.clientX) + this.state.offsetX,
        positionY: (this.state.startY - event.clientY) + this.state.offsetY,
      });
    }
  }

  render (){
    const style = {transform: `translate(${-this.state.positionX}px, ${-this.state.positionY}px)`};
    console.log(style);
    return (
      <div className={this.props.className || 'draggable-container'} onDragStart={this.startDrag} onDrag={this.drag} style={style} onDragEnd={this.stopDrag} onDragOver={e=> e.preventDefault()} onClick={this.reset}>
        {this.props.children}
      </div>
    )
  }
}

export default Draggable;



// WEBPACK FOOTER //
// ./src/app/components/Events/Draggable.js